import React from "react";
import { emptyQuantityTier } from "../constants/dropshippingInterneConstants";
import "./ProviderProductPriceTiers.css";
import { elakayAutoText } from "../../pageInside/dataElakay";


// spec §4 -- le Provider construit ses propres paliers de prix de gros,
// jamais une liste [12,24,36,48,100,1000] figée. Chaque ligne choisit soit un
// prix unitaire fixe soit une réduction en %, jamais les deux (même règle
// que QuantityPricingTierSchema côté backend, voir
// server_elakay/dropshippingInterne/models/ProviderProduct.js).
const ProviderProductPriceTiers = ({ tiers, onChange }) => {
  const rows = tiers && tiers.length ? tiers : [];

  const updateRow = (index, patch) => {
    const next = rows.map((row, i) => (i === index ? { ...row, ...patch } : row));
    onChange(next);
  };

  const addRow = () => onChange([...rows, emptyQuantityTier()]);
  const removeRow = (index) => onChange(rows.filter((_, i) => i !== index));

  return (
    <div className="provider-price-tiers">
      <div className="provider-price-tiers__header">
        <span>{elakayAutoText("h_b1d66dcc51dca0", "Min qty")}</span>
        <span>{elakayAutoText("h_92ebf411766111", "Max qty (optional)")}</span>
        <span>{elakayAutoText("h_a0d9bbad5f932e", "Pricing")}</span>
        <span>{elakayAutoText("h_8dce170de238b1", "Value")}</span>
        <span />
      </div>

      {rows.map((row, index) => (
        <div className="provider-price-tiers__row" key={index}>
          <input
            type="number"
            min="1"
            placeholder="e.g. 12"
            value={row.minQuantity}
            onChange={(e) => updateRow(index, { minQuantity: e.target.value })}
          />
          <input
            type="number"
            min="1"
            placeholder={elakayAutoText("h_2e991b1ceb351c", "No cap")}
            value={row.maxQuantity}
            onChange={(e) => updateRow(index, { maxQuantity: e.target.value })}
          />
          <select
            value={row.pricingType}
            onChange={(e) => updateRow(index, { pricingType: e.target.value })}
          >
            <option value="unitPrice">{elakayAutoText("h_35cc0c17fc744f", "Fixed unit price")}</option>
            <option value="discountPercent">{elakayAutoText("h_0cd95d4129bd90", "Discount %")}</option>
          </select>
          {row.pricingType === "unitPrice" ? (
            <input
              type="number"
              min="0"
              step="0.01"
              placeholder={elakayAutoText("h_8fc27117f5b40d", "$ / unit")}
              value={row.unitPrice}
              onChange={(e) => updateRow(index, { unitPrice: e.target.value })}
            />
          ) : (
            <input
              type="number"
              min="0"
              max="100"
              step="0.1"
              placeholder={elakayAutoText("h_13bcf4da770a67", "% off base price")}
              value={row.discountPercent}
              onChange={(e) => updateRow(index, { discountPercent: e.target.value })}
            />
          )}
          <button
            type="button"
            className="provider-price-tiers__remove"
            onClick={() => removeRow(index)}
            aria-label={elakayAutoText("h_4235e72ea8bce8", "Remove tier {value0}", { value0: index + 1 })}
          >
            ×
          </button>
        </div>
      ))}

      <button type="button" className="provider-price-tiers__add" onClick={addRow}>{elakayAutoText("h_6defa3fe88d78e", "+ Add a quantity tier")}</button>
    </div>
  );
};

export default ProviderProductPriceTiers;
